import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { useTheme } from '@mui/material/styles'
import React from 'react'
import DeleteIcon from '@mui/icons-material/DeleteSweep'
import { useTranslation } from 'react-i18next'
import { getButtonTestId } from '../Buttons/getButtonTestId'

/** @notExported  */
interface DeleteButtonProps {
  /** Action to perform when button is clicked. */
  clickAction: (event?: React.MouseEvent<HTMLButtonElement>) => void
  /** Tooltip for button. */
  tooltip?: string
  /** Size of the button. */
  size?: 'medium' | 'small' | undefined
  /** Test id of the button. */
  testId?: string
}

/**
 * Delete button component.
 *
 * @returns Delete button component.
 * @notExported
 * @category Buttons
 */
const DeleteButton: React.FC<DeleteButtonProps> = ({ clickAction, tooltip, size = 'small', testId }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const label = tooltip ?? (t('delete') as string)
  const resolvedTestId = getButtonTestId({ fallback: 'button-delete-icon', label, testId })

  const getButton = () => {
    return (
      <IconButton
        aria-label={label}
        data-testid={resolvedTestId}
        sx={{ '&:hover': { backgroundColor: theme.palette.error.light, color: theme.palette.error.dark } }}
        onClick={event => clickAction(event)}
        size={size}
      >
        <DeleteIcon />
      </IconButton>
    )
  }
  return (
    <Tooltip title={label} describeChild>
      {getButton()}
    </Tooltip>
  )
}

export default DeleteButton
